import(/* webpackMode: "eager" */ "/private/tmp/statura-proddeploy-DNF9tE/apps/web/src/app/error.tsx");
